import React from 'react';
import StatusContext from '../../../contexts/StatusContext'
import {TestActivity} from "../aitest/TestActivity"
import AITestContext from '../../../contexts/AITestContext'
import {PushButton} from '../pushbutton/PushButton'


export const Account = ({ balance }) => {

let {
    changeLanguage,
    setShowCreateConnectAccountDialog,
  } = React.useContext(StatusContext);

  let {
    connectedAccount,
    setVerifyAccount,
   
  } = React.useContext(AITestContext);

  const onClickCreateAccount = () => {

    setVerifyAccount(false)
    setShowCreateConnectAccountDialog(true)
  
  }
  
  const onClickNewAccount = () => {
  
    setVerifyAccount(false)
    setShowCreateConnectAccountDialog(true)
  
  }

 
  return (
    <div className= 'accountContainer'>
      <div>
        <br></br>
        <label style={{fontWeight:'700', fontStyle:'oblique'}}>{changeLanguage('aitest', 'accountcapital')}</label>
      </div>

     

      {
        !connectedAccount.verified &&
        <>
        <div>
          {changeLanguage('aitest', 'createaccounttext')}
        </div>
       
        <PushButton onClick={onClickCreateAccount} label =  {changeLanguage('aitest','createaccount')}/>
    
        <br></br>
   
        </>
      }

      {
        connectedAccount.verified && 
        <>
        <div>
          {changeLanguage('aitest', 'changeaccounttext')}
          <br></br>
          {changeLanguage('aitest', 'accountverificationtext')}
        </div>
            <PushButton onClick={onClickNewAccount} label =  {changeLanguage('aitest','changeaccount')}/>
       
        <br></br>
        </>
      }

      <br></br>
      <div>
        <label className='aitestPrice'>{changeLanguage('aitest', 'totalearnings')}</label>
        <label className='aitestPriceInput'>{balance}</label>
      </div>

        <TestActivity />

        <br></br>
     
    </div>
   
  );
};

